import React, { useEffect } from 'react';
import { useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { useLogin } from 'auth/useLogin';
import { useHistory } from 'react-router-dom';
import { Spinner } from '@vwfs-bronson/bronson-react';
import { dashboardPagePath } from 'components/navigation/paths';

export const LoginRedirect: React.FC = () => {
    const { isAuthenticated } = useOidcAuthentication();
    const login = useLogin();
    const history = useHistory();

    useEffect(() => {
        if (!isAuthenticated) {
            login();
        } else {
            history.push(dashboardPagePath());
        }
    }, [history, isAuthenticated, login]);

    return <Spinner center />;
};
